/*
 * @Description:
 * @Date: 2024-12-12 11:54:05
 */
import IncomeRedirect from '../views/income-redirect.vue';

export const route = [
  {
    path: '/income-redirect',
    component: IncomeRedirect,
    meta: {
      title: '收入单'
    }
  }
];
